/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 8/2/2023
 */

import React, { useState, useEffect } from "react"
import Uppy from "@uppy/core"
import { Dashboard } from "@uppy/react"
import XHR from "@uppy/xhr-upload"
import StorageService from "../../../../base/services/StorageService"
import { Alert } from "@mui/material"

import "@uppy/core/dist/style.min.css"
import "@uppy/dashboard/dist/style.min.css"

const UploadZone = ({ orgCode, action, grpIdList, fromGrpID, fromGroup }) => {
  const [token, setToken] = useState()
  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  useEffect(() => {
    setToken(StorageService.getAccessToken())
  }, [])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror) === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror])

  const headers = {
    authorization: "bearer " + token,
    "Accept-Version": "1.0",
    action: action,
  }

  const payload = {
    orgCode: orgCode,
    desc: "",
    applicationId: null,
    linkGrpIdList: fromGroup ? fromGrpID : grpIdList,
  }

  const app_detail = new Blob([JSON.stringify(payload)], {
    type: "application/json",
  })

  const uppy = new Uppy({ meta: { application_details: app_detail } }).use(
    XHR,
    {
      endpoint: process.env.REACT_APP_RES_API_URL + "/applications",
      headers: headers,
      formData: true,
      fieldName: "application",
      allowedMetaFields: ["application_details"],
      getResponseError(responseText, response) {
        setIserror(true)
        setErrorMessages([JSON.parse(responseText).description])
        return new Error(JSON.parse(responseText).description)
      },
    }
  )
  return (
    <div>
      <div>
        {iserror && (
          <Alert severity="error">
            {errorMessages.map((msg, i) => {
              return <div key={msg}>{msg}</div>
            })}
          </Alert>
        )}
      </div>
      <Dashboard
        showProgressDetails={true}
        proudlyDisplayPoweredByUppy={false}
        uppy={uppy}
      />
    </div>
  )
}

export default UploadZone
